import { useEffect, useState } from "react";
import client from "../api/client";

export default function ApiHealthBadge() {
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    let alive = true;
    client
      .get("/health")
      .then((res) => {
        if (!alive) return;
        setStatus(res.data?.database === "Online" ? "online" : "degraded");
      })
      .catch(() => alive && setStatus("offline"));
    return () => {
      alive = false;
    };
  }, []);

  const map = {
    online: { text: "API Online", cls: "text-success", icon: "bi-check-circle" },
    degraded: { text: "DB Check", cls: "text-warning", icon: "bi-exclamation-triangle" },
    offline: { text: "API Offline", cls: "text-danger", icon: "bi-x-circle" },
    checking: { text: "Checking API", cls: "text-muted", icon: "bi-hourglass-split" },
  };
  const item = map[status] || map.checking;

  return (
    <span
      className={`d-inline-flex align-items-center gap-1 ${item.cls}`}
      style={{ fontSize: 10, fontWeight: 700 }}
      title="Production health check"
    >
      <i className={`bi ${item.icon}`}></i>
      {item.text}
    </span>
  );
}
